/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import { LinkAccountsButton, LinkAccountsSelect } from 'components';

import { styles } from './styles';

const LinkedAccounts = () => {
	return (
		<Box sx={styles.root}>
			<Box sx={styles.button_group}>
				<List>
					<ListItem>
						<LinkAccountsButton account={'hubspot'} />
						<Box style={{ display: 'flex', flexDirection: 'column' }}>
							<Typography component={'span'} variant="h5" color="primary">
								HUBSPOT
							</Typography>
							<Typography component={'span'} variant="subtitle2" color="secondary">
								LINK HUBSPOT
							</Typography>
						</Box>
					</ListItem>
					<LinkAccountsSelect />
				</List>
			</Box>
		</Box>
	);
};

export default LinkedAccounts;
